import { CustomScheduledReportModel } from "./CustomScheduledReport.model";

export class CustomScheduledReport extends CustomScheduledReportModel {
    // Add custom methods here
}
